import React from 'react';

import Column from '@amzn/meridian/column';
import MeridianInput from '@amzn/meridian/input';
import { InputSize, InputType } from '@amzn/meridian/input/input';
import InputMask from '@amzn/meridian/input/mask';
import Text from '@amzn/meridian/text';
import { TextType } from '@amzn/meridian/text/text';

import { InputValidationRuleType } from 'src/constants';

import { inputValidationRuleMap } from './inputValidationRuleMap';

interface IInputProps {
    label: string;
    value: string;
    type?: InputType | undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange?: (value: any) => void;
    onBlur?: () => void;
    handleErrMsgChange?: (value: string) => void;
    isEditMode: boolean;
    isRequired?: boolean;
    placeholder?: string;
    disabled?: boolean;
    width?: string;
    size?: InputSize;
    mask?: InputMask | undefined;
    errorMessage?: string;
    validationRules?: InputValidationRuleType[];
    pattern?: RegExp;
    readModeLabelType?: TextType;
}

export const Input = ({
    label,
    value,
    type,
    onChange,
    onBlur,
    handleErrMsgChange,
    isEditMode = true,
    isRequired = false,
    placeholder = '',
    disabled = false,
    width,
    size = 'xlarge',
    mask = undefined,
    errorMessage,
    validationRules = [],
    pattern,
    readModeLabelType = 'b200'
}: IInputProps) => {
    const handleBlur = () => {
        if (onBlur) {
            return onBlur();
        }

        if (validationRules.length === 0 || !handleErrMsgChange) return;

        let errMsg;

        for (const rule of validationRules) {
            if (!inputValidationRuleMap.get(rule)?.method(value)) {
                errMsg = inputValidationRuleMap.get(rule)?.errorMessage;
                break;
            }
        }

        if (handleErrMsgChange) handleErrMsgChange(errMsg || '');
    };

    return (
        <Column spacing="100">
            {!isEditMode && <Text type={readModeLabelType}>{label}</Text>}
            {isEditMode ? (
                <MeridianInput
                    label={label + (isRequired ? ' *' : '')}
                    type={type}
                    size={size}
                    width={width}
                    value={value}
                    onChange={onChange}
                    onBlur={handleBlur}
                    placeholder={placeholder}
                    disabled={disabled}
                    mask={mask}
                    error={!!errorMessage}
                    errorMessage={errorMessage}
                    pattern={pattern}
                />
            ) : (
                <Text type="b300">{value || 'n/a'}</Text>
            )}
        </Column>
    );
};
